import React, { useEffect, useState } from "react"
import "./Dropdown.scss"

interface SelectedDropdown {
  selected: string
  options: any
  width?: string
  height?: string | null
  updateDropdown?: any
  errorMsg?: string
  placeholder?: string
  disable?: boolean,
  className?: any
}

function Dropdown({
  selected,
  width = "auto",
  options,
  updateDropdown,
  errorMsg = "",
  placeholder = "",
  disable = false,
  className,
}: SelectedDropdown) {
  const [isActive, setIsActive] = useState(false)
  const [dropdownValues, updateDropdownValues] = useState<any>()
  const [selectedValue, updateSelectedValue] = useState<any>("")

  useEffect(() => {
    if (options?.length > 0) {
      if (typeof options[0] === "string" || typeof options[0] === "boolean") {
        const temp = options?.map((each: any) => {
          return { label: each, value: each }
        })
        updateDropdownValues(temp)
      } else if (typeof options[0] === "object") {
        updateDropdownValues(options)
      }
    }
  }, [options])

  useEffect(() => {
    if (dropdownValues?.length > 0) {
      if (selected) {
        const temp = dropdownValues?.find(
          (eachItem: any) => eachItem?.value === selected
        )
        updateSelectedValue(temp?.label)
      } else {
        updateSelectedValue("")
      }
    }
  }, [selected, dropdownValues])

  return (
    <div
      className={`custom-dropdown ${className ? className : ''}`}
      // style={{ width: width }}
      onMouseLeave={(e) => setIsActive(false)}
    >
      <div
        className={`dropdown-button ${disable ? "disable" : ""}`}
        onClick={(e) => !disable && setIsActive(!isActive)}
      >
        <div className="text">
          {selectedValue === "" ? placeholder : selectedValue}
        </div>
        <div className="icon">
          <img src="../../assets/images/down-arrow.svg" alt="down arrow" className="down_arrow" />
        </div>
      </div>
      {isActive && (
        <div
          className="dropdown-content"
        // style={{ width: parseInt(width) * 0.97 }}
        >
          {dropdownValues?.map((option: any, index: any) => (
            <div
              className="dropdown-item"
              key={index}
              onClick={(e) => {
                setIsActive(false)
                updateDropdown && updateDropdown(option?.value)
              }}
            >
              {option?.label}

            </div>
          ))}
        </div>
      )}
      {errorMsg && <div className="error">{errorMsg}</div>}
    </div>
  )
}

export default Dropdown
